import { Component, OnInit } from "@angular/core";
@Component({
    selector: 'trusted-dialog',
    templateUrl: 'trusted.html',
    styleUrls: ['../Trusted-site.css'],
    standalone: false
})
  export class TrustedBTNDialog implements OnInit{
 
  ngOnInit(): void {
  }

  async onSubmit() {
  }
}